import { Component } from '@angular/core'

@Component({
  selector: 'cluster-plan-details-page',
  templateUrl: './cluster-plan-details.page.html',
})
export class ClusterPlanDetailsPage {}
